import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { apiError } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C] px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="font-display font-black text-2xl tracking-[0.15em]">AL<span className="text-gold">MUSIC</span> RECORDS</div>
          <div className="eyebrow mt-2">Espace administration</div>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="card-dark p-8 space-y-5">
          <div className="w-12 h-12 rounded-xl bg-amber-400/10 border border-amber-400/20 flex items-center justify-center mx-auto"><Lock className="text-gold" size={20} /></div>
          <div><label className="label-dark">Email</label><input type="email" data-testid="admin-email" className="input-dark" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
          <div><label className="label-dark">Mot de passe</label><input type="password" data-testid="admin-password" className="input-dark" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
          <button disabled={loading} data-testid="admin-login-submit" className="btn-gold w-full justify-center">{loading ? "Connexion…" : "Se connecter"}</button>
        </form>
      </div>
    </div>
  );
}
